import { BasketService } from "../api";
import { useTranslations } from "../hooks/useTranslations";
import { webComponent } from "../services/webComponentService";
import { BuyButtonProps } from "../types/components/BuyButtonProps";

function BuyButton(props: BuyButtonProps) {
	const { articleNumber } = props;
	const t = useTranslations();

	function onClick() {
		BasketService.addToBasket({ body: { partNo: articleNumber, quantity: 1 } });
	}

	return (
		<button
			type="button"
			onClick={onClick}
			className="button-primary-large-extended mt-3"
		>
			{t.addToCart}
		</button>
	);
}

export default webComponent("buy-button", BuyButton);
